/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetSurveyParams,
  MoveSurveyQuestionInput,
  PaginatedSurveyResponses,
  SchemaValidationErrorResponse,
  Survey,
  SurveyQuestion,
  SurveyQuestionRequestInput,
  SurveyRequestInput,
  SurveyResponse,
  SurveyResponseRequestInput,
  SurveyResponsesParams,
  SurveyResults,
  SurveyResultsParams,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Delete Survey Question
 */
export const deleteSurveyQuestion = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/surveys/questions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteSurveyQuestionMutationKey = () => ['deleteSurveyQuestion'] as const;

export const getDeleteSurveyQuestionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestion>>, TError,DeleteSurveyQuestionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestion>>, TError,DeleteSurveyQuestionMutationVariables, TContext> => {

const mutationKey = getDeleteSurveyQuestionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSurveyQuestion>>, DeleteSurveyQuestionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteSurveyQuestion(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSurveyQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSurveyQuestion>>>

    export type DeleteSurveyQuestionMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteSurveyQuestionMutationVariables = {id: string}

    /**
 * @summary Delete Survey Question
 */
export const useDeleteSurveyQuestion = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestion>>, TError,DeleteSurveyQuestionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSurveyQuestion>>,
        TError,
        DeleteSurveyQuestionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSurveyQuestionMutationOptions(options), queryClient);
    }
    /**
 * @summary Survey Question Details
 */
export const getSurveyQuestion = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SurveyQuestion>(
      {url: `/surveys/questions/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetSurveyQuestionQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'surveys','questions',id
    ] as const;
    }


export const getGetSurveyQuestionQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyQuestion>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSurveyQuestionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyQuestion>>> = ({ signal }) => getSurveyQuestion(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestion>>, TError, TData>
}

export type GetSurveyQuestionQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyQuestion>>>
export type GetSurveyQuestionQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Survey Question Details
 */

export function useGetSurveyQuestion<TData = Awaited<ReturnType<typeof getSurveyQuestion>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestion>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyQuestionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Survey Question
 */
export const updateSurveyQuestion = (
    id: MaybeRefOrGetter<string>,
    surveyQuestionRequestInput: MaybeRefOrGetter<SurveyQuestionRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
surveyQuestionRequestInput = toValue(surveyQuestionRequestInput);

      return axiosClient<SurveyQuestion>(
      {url: `/surveys/questions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: surveyQuestionRequestInput, signal
    },
      );
    }




export const getUpdateSurveyQuestionMutationKey = () => ['updateSurveyQuestion'] as const;

export const getUpdateSurveyQuestionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSurveyQuestion>>, TError,UpdateSurveyQuestionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSurveyQuestion>>, TError,UpdateSurveyQuestionMutationVariables, TContext> => {

const mutationKey = getUpdateSurveyQuestionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSurveyQuestion>>, UpdateSurveyQuestionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateSurveyQuestion(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSurveyQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSurveyQuestion>>>
    export type UpdateSurveyQuestionMutationBody = SurveyQuestionRequestInput
    export type UpdateSurveyQuestionMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateSurveyQuestionMutationVariables = {id: string;data: SurveyQuestionRequestInput}

    /**
 * @summary Update Survey Question
 */
export const useUpdateSurveyQuestion = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSurveyQuestion>>, TError,UpdateSurveyQuestionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateSurveyQuestion>>,
        TError,
        UpdateSurveyQuestionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSurveyQuestionMutationOptions(options), queryClient);
    }
    /**
 * @summary Move Survey Question
 */
export const moveSurveyQuestion = (
    id: MaybeRefOrGetter<string>,
    moveSurveyQuestionInput: MaybeRefOrGetter<MoveSurveyQuestionInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
moveSurveyQuestionInput = toValue(moveSurveyQuestionInput);

      return axiosClient<SurveyQuestion>(
      {url: `/surveys/questions/${id}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: moveSurveyQuestionInput, signal
    },
      );
    }




export const getMoveSurveyQuestionMutationKey = () => ['moveSurveyQuestion'] as const;

export const getMoveSurveyQuestionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveSurveyQuestion>>, TError,MoveSurveyQuestionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveSurveyQuestion>>, TError,MoveSurveyQuestionMutationVariables, TContext> => {

const mutationKey = getMoveSurveyQuestionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveSurveyQuestion>>, MoveSurveyQuestionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  moveSurveyQuestion(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveSurveyQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof moveSurveyQuestion>>>
    export type MoveSurveyQuestionMutationBody = MoveSurveyQuestionInput
    export type MoveSurveyQuestionMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type MoveSurveyQuestionMutationVariables = {id: string;data: MoveSurveyQuestionInput}

    /**
 * @summary Move Survey Question
 */
export const useMoveSurveyQuestion = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveSurveyQuestion>>, TError,MoveSurveyQuestionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveSurveyQuestion>>,
        TError,
        MoveSurveyQuestionMutationVariables,
        TContext
      > => {
      return useMutation(getMoveSurveyQuestionMutationOptions(options), queryClient);
    }
    /**
 * @summary Survey Response Details
 */
export const getSurveyResponse = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SurveyResponse>(
      {url: `/surveys/responses/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetSurveyResponseQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'surveys','responses',id
    ] as const;
    }


export const getGetSurveyResponseQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyResponse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyResponse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSurveyResponseQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyResponse>>> = ({ signal }) => getSurveyResponse(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyResponse>>, TError, TData>
}

export type GetSurveyResponseQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyResponse>>>
export type GetSurveyResponseQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Survey Response Details
 */

export function useGetSurveyResponse<TData = Awaited<ReturnType<typeof getSurveyResponse>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyResponse>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyResponseQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Survey Details
 */
export const getSurvey = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetSurveyParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<Survey>(
      {url: `/surveys/surveys/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetSurveyQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetSurveyParams>,) => {
    return [
    'surveys','surveys',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSurveyQueryOptions = <TData = Awaited<ReturnType<typeof getSurvey>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetSurveyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSurveyQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurvey>>> = ({ signal }) => getSurvey(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>
}

export type GetSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof getSurvey>>>
export type GetSurveyQueryError = ErrorType<void>


/**
 * @summary Survey Details
 */

export function useGetSurvey<TData = Awaited<ReturnType<typeof getSurvey>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetSurveyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Survey
 */
export const updateSurvey = (
    id: MaybeRefOrGetter<string>,
    surveyRequestInput: MaybeRefOrGetter<SurveyRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
surveyRequestInput = toValue(surveyRequestInput);

      return axiosClient<Survey>(
      {url: `/surveys/surveys/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: surveyRequestInput, signal
    },
      );
    }




export const getUpdateSurveyMutationKey = () => ['updateSurvey'] as const;

export const getUpdateSurveyMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSurvey>>, TError,UpdateSurveyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSurvey>>, TError,UpdateSurveyMutationVariables, TContext> => {

const mutationKey = getUpdateSurveyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSurvey>>, UpdateSurveyMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateSurvey(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof updateSurvey>>>
    export type UpdateSurveyMutationBody = SurveyRequestInput
    export type UpdateSurveyMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateSurveyMutationVariables = {id: string;data: SurveyRequestInput}

    /**
 * @summary Update Survey
 */
export const useUpdateSurvey = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSurvey>>, TError,UpdateSurveyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateSurvey>>,
        TError,
        UpdateSurveyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSurveyMutationOptions(options), queryClient);
    }
    /**
 * @summary Survey Results
 */
export const surveyResults = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SurveyResultsParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<SurveyResults>(
      {url: `/surveys/surveys/${id}/results`, method: 'GET',
        params, signal
    },
      );
    }




export const getSurveyResultsQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SurveyResultsParams>,) => {
    return [
    'surveys','surveys',id,'results', ...(params ? [params] : [])
    ] as const;
    }


export const getSurveyResultsQueryOptions = <TData = Awaited<ReturnType<typeof surveyResults>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SurveyResultsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSurveyResultsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveyResults>>> = ({ signal }) => surveyResults(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof surveyResults>>, TError, TData>
}

export type SurveyResultsQueryResult = NonNullable<Awaited<ReturnType<typeof surveyResults>>>
export type SurveyResultsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Survey Results
 */

export function useSurveyResults<TData = Awaited<ReturnType<typeof surveyResults>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SurveyResultsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyResults>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSurveyResultsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Survey Question
 */
export const createSurveyQuestion = (
    surveyId: MaybeRefOrGetter<string>,
    surveyQuestionRequestInput: MaybeRefOrGetter<SurveyQuestionRequestInput>,
 signal?: AbortSignal
) => {
      surveyId = toValue(surveyId);
surveyQuestionRequestInput = toValue(surveyQuestionRequestInput);

      return axiosClient<SurveyQuestion>(
      {url: `/surveys/surveys/${surveyId}/questions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: surveyQuestionRequestInput, signal
    },
      );
    }




export const getCreateSurveyQuestionMutationKey = () => ['createSurveyQuestion'] as const;

export const getCreateSurveyQuestionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSurveyQuestion>>, TError,CreateSurveyQuestionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSurveyQuestion>>, TError,CreateSurveyQuestionMutationVariables, TContext> => {

const mutationKey = getCreateSurveyQuestionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSurveyQuestion>>, CreateSurveyQuestionMutationVariables> = (props) => {
          const {surveyId,data} = props ?? {};

          return  createSurveyQuestion(surveyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSurveyQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof createSurveyQuestion>>>
    export type CreateSurveyQuestionMutationBody = SurveyQuestionRequestInput
    export type CreateSurveyQuestionMutationError = ErrorType<void>
    export type CreateSurveyQuestionMutationVariables = {surveyId: string;data: SurveyQuestionRequestInput}

    /**
 * @summary Create Survey Question
 */
export const useCreateSurveyQuestion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSurveyQuestion>>, TError,CreateSurveyQuestionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSurveyQuestion>>,
        TError,
        CreateSurveyQuestionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSurveyQuestionMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Survey Response
 */
export const createSurveyResponse = (
    surveyId: MaybeRefOrGetter<string>,
    surveyResponseRequestInput: MaybeRefOrGetter<SurveyResponseRequestInput>,
 signal?: AbortSignal
) => {
      surveyId = toValue(surveyId);
surveyResponseRequestInput = toValue(surveyResponseRequestInput);

      return axiosClient<SurveyResponse>(
      {url: `/surveys/surveys/${surveyId}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: surveyResponseRequestInput, signal
    },
      );
    }




export const getCreateSurveyResponseMutationKey = () => ['createSurveyResponse'] as const;

export const getCreateSurveyResponseMutationOptions = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSurveyResponse>>, TError,CreateSurveyResponseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSurveyResponse>>, TError,CreateSurveyResponseMutationVariables, TContext> => {

const mutationKey = getCreateSurveyResponseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSurveyResponse>>, CreateSurveyResponseMutationVariables> = (props) => {
          const {surveyId,data} = props ?? {};

          return  createSurveyResponse(surveyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSurveyResponseMutationResult = NonNullable<Awaited<ReturnType<typeof createSurveyResponse>>>
    export type CreateSurveyResponseMutationBody = SurveyResponseRequestInput
    export type CreateSurveyResponseMutationError = ErrorType<void | ValidationError>
    export type CreateSurveyResponseMutationVariables = {surveyId: string;data: SurveyResponseRequestInput}

    /**
 * @summary Create Survey Response
 */
export const useCreateSurveyResponse = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSurveyResponse>>, TError,CreateSurveyResponseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSurveyResponse>>,
        TError,
        CreateSurveyResponseMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSurveyResponseMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Survey Responses
 */
export const surveyResponses = (
    surveyId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SurveyResponsesParams>,
 signal?: AbortSignal
) => {
      surveyId = toValue(surveyId);
params = toValue(params);

      return axiosClient<PaginatedSurveyResponses>(
      {url: `/surveys/surveys/${surveyId}/responses`, method: 'GET',
        params, signal
    },
      );
    }




export const getSurveyResponsesQueryKey = (surveyId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SurveyResponsesParams>,) => {
    return [
    'surveys','surveys',surveyId,'responses', ...(params ? [params] : [])
    ] as const;
    }


export const getSurveyResponsesQueryOptions = <TData = Awaited<ReturnType<typeof surveyResponses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(surveyId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SurveyResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyResponses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSurveyResponsesQueryKey(surveyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveyResponses>>> = ({ signal }) => surveyResponses(surveyId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(surveyId) !== null && toValue(surveyId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof surveyResponses>>, TError, TData>
}

export type SurveyResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof surveyResponses>>>
export type SurveyResponsesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Survey Responses
 */

export function useSurveyResponses<TData = Awaited<ReturnType<typeof surveyResponses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 surveyId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SurveyResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyResponses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSurveyResponsesQueryOptions(surveyId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






